import React from "react";

import BottomNavigation from "@mui/material/BottomNavigation";
import Paper from "@mui/material/Paper";

import "./BottomBar.css";

interface props {
	alerts: number;
}

const BottomBar: React.FC<props> = ({ alerts }) => {
	const [value, setValue] = React.useState(0);
	return (
		<Paper
			sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
			elevation={3}
			className="mobi-paper"
		>
			<BottomNavigation
				className="bottom-bar"
				showLabels
				value={value}
				onChange={(event, newValue) => {
					setValue(newValue);
				}}
			>
				<div className="bell-icon-div">
					<div className="bell-icon-number">{alerts}</div>
					<img
						src="/media/icons/bell.png"
						alt="bell notification"
						className="bell-icon"
					/>
				</div>
			</BottomNavigation>
		</Paper>
	);
};

export default BottomBar;
